import { PageDto } from '@linkie/domain';
import { ENUM_DOMAIN_STATUS } from '@linkie/shared';
import { DEFAULT_APPEARANCE_SETTINGS } from '@linkie/shared';
import type { PlaygroundPayload } from '@linkie/shared';

export const toPlaygroundPayload = (linkie: PageDto): PlaygroundPayload => ({
  _id: linkie?._id || '',
  username: linkie?.username || '',
  name: linkie?.name || '',
  title: linkie?.title || '',
  bio: linkie?.bio || '',
  cta_button: {
    label: linkie?.cta_button?.label || '',
    url: linkie?.cta_button?.url || '',
  },
  banner: {
    text: linkie?.banner?.text || '',
    url: linkie?.banner?.url || '',
  },
  domain: linkie?.domain || '',
  domain_status: linkie?.domain_status || ENUM_DOMAIN_STATUS.PENDING,
  custom_hostname_id: linkie?.custom_hostname_id || '',
  ownership_verification: {
    type: linkie?.ownership_verification?.type || '',
    name: linkie?.ownership_verification?.name || '',
    value: linkie?.ownership_verification?.value || '',
  },
  privacy_policy_url: linkie?.privacy_policy_url || '',
  cards: linkie?.cards || [],
  mailing_integrations: linkie?.mailing_integrations || [],
  page_settings: {
    title: linkie?.page_settings?.title || '',
    description: linkie?.page_settings?.description || '',
    show_page_in_search_engines: linkie?.page_settings?.show_page_in_search_engines ?? true,
    favico_url: linkie?.page_settings?.favico_url || '',
    social_image_url: linkie?.page_settings?.social_image_url || '',
  },
  appearance_settings: {
    accent_color: linkie?.appearance_settings?.accent_color || DEFAULT_APPEARANCE_SETTINGS.accent_color,
    theme: linkie?.appearance_settings?.theme || DEFAULT_APPEARANCE_SETTINGS.theme,
    columns: linkie?.appearance_settings?.columns || DEFAULT_APPEARANCE_SETTINGS.columns,
    show_social_icons: linkie?.appearance_settings?.show_social_icons,
    hide_share_button: linkie?.appearance_settings?.hide_share_button,
    bypass_in_app_browser: linkie?.appearance_settings?.bypass_in_app_browser,
  },
  posts_settings: linkie?.posts_settings ?? null,
  subscription: linkie?.subscription || null,
  is_paid: linkie?.is_paid,
  avatar_url: linkie?.avatar_url || '',
});
